module.exports = __webpack_public_path__ + "2fce96255929a4e735ed48b59cecca47.jpg";